export default __webpack_public_path__ + "static/media/28t.a6ad461c.jpg";